document.addEventListener("teeinblue-event-component-injected", function () {
  const interval = 100;
  const duration = 5000;

  const clickInterval = setInterval(() => {
    const elements = document.querySelector(
      ".tee-mockup-item.tee-mockup-item--loaded"
    );
    elements.click();
  }, interval);

  setTimeout(() => {
    clearInterval(clickInterval);
  }, duration);
});
